module.exports = __webpack_public_path__ + "static/media/manage_departments_click_back_and_assign.a787fd4d.mov";